// extracted by mini-css-extract-plugin
export var container = "_9t-0";
export var error = "_9t-9";
export var label = "_9t-5";
export var light = "_9t-6";
export var md = "_9t-3";
export var sm = "_9t-2";
export var thin = "_9t-8";
export var thinBold = "_9t-7";
export var vertical = "_9t-4";
export var xs = "_9t-1";